import PropTypes from "prop-types";
import React from "react";
import activeVoucherImage from "../../assets/images/wallet/active-voucher.svg";
import expireVoucherImage from "../../assets/images/wallet/expire-voucher.svg";
import redeemedVoucherImage from "../../assets/images/wallet/redeemed-voucher.svg";
import giftIcon from "../../assets/images/wallet/gift.svg";
import tickCircleIcon from "../../assets/images/wallet/tick-circle.svg";
import timerIcon from "../../assets/images/wallet/timer.svg";
import SecondaryButton from "./SecondaryButton";
import whiteArrow from "../../assets/images/user-dashboard/white-right-arrow.svg";

/* -------------------------------------------------------------------------
 * VoucherCard — the notched "ticket" card used on both the Vouchers page
 * and the Wallet page. Uses different background images for each status.
 * ---------------------------------------------------------------------- */

const STATUS_ICON = {
  active: giftIcon,
  redeemed: tickCircleIcon,
  expired: timerIcon,
};

const BACKGROUND_IMAGE = {
  active: activeVoucherImage,
  redeemed: redeemedVoucherImage,
  expired: expireVoucherImage,
};

const STATUS_LABEL_PREFIX = {
  active: "Valid till",
  redeemed: "Redeemed on",
  expired: "Expired on",
};

// Format ISO date to readable format (e.g., "Jul 6, 2027")
const formatDate = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch (e) {
    return dateString;
  }
};

const VoucherCard = ({ amount, status, statusDate, restaurantName, voucherCode, onRedeem }) => (
  <div
    className={`voucher-card voucher-card--${status}`}
    style={{ backgroundImage: `url(${BACKGROUND_IMAGE[status]})` }}
  >
    <div className="voucher-card__stub">
      {voucherCode ? (
        <span className="voucher-card__code">${amount}</span>
      ) : (
        <img src={STATUS_ICON[status]} alt="" />
      )}
    </div>

    <div className="voucher-card__body">

      <div className="voucher-card__top">
        <div className="voucher-card__valid-at">
          <span className="voucher-card__valid-label">Valid at:</span>
          <span className="voucher-card__restaurant">{restaurantName}</span>
        </div>
        
        
      </div>

      <div className="voucher-card__bottom">
        <div className="voucher-card__valid-at">
          <div className="voucher-card__pill">
            <span className="voucher-card__pill__prefix">{STATUS_LABEL_PREFIX[status]}:</span>
            <span className="voucher-card__pill__date">{formatDate(statusDate)}</span>
          </div>
        </div>

        <SecondaryButton
          label={status === "active" ? "Redeem" : status === "redeemed" ? "Redeemed" : "Expired"}
          variant={status === "expired" ? "light-red" : "black"}
          icon={status === "active" ? whiteArrow : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onRedeem();
          }}
        />
      </div>
    </div>
  </div>
);

VoucherCard.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  status: PropTypes.oneOf(["active", "redeemed", "expired"]).isRequired,
  statusDate: PropTypes.string.isRequired,
  restaurantName: PropTypes.string.isRequired,
  voucherCode: PropTypes.string,
  onRedeem: PropTypes.func,
  onClick: PropTypes.func,
};

VoucherCard.defaultProps = {
  voucherCode: "",
  onRedeem: () => {},
  onClick: () => {},
};

export default VoucherCard;
